module.exports = __webpack_public_path__ + "static/img/6538_phase_function_Paper_Points.911b7b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6538_phase_function_Paper_Points.png
// module id = GBv3
// module chunks = 0